import styled from '@emotion/styled';

const CancelDeletionButtonWrapper = styled('div')({
  position: 'relative',
  display: 'inline-block',
});

export default CancelDeletionButtonWrapper;
